import { type ChangeEvent } from 'react';

import { ErrorIcon } from '@Views/Shared/Icons';

type InputType = {
	placeholder?: string;
	name: string;
	id: string;
	autoComplete?: string;
	required: boolean;
	label: string;
	onChange: React.ChangeEventHandler<HTMLInputElement>;
	htmlFor: string;
	type: string;
	ariaLabel: string;
	disabled?: boolean;
	className?: string;
	description?: string | null;
	errorMessage?: string;
};

export default function Input(props: InputType) {
	const {
		placeholder,
		name,
		id,
		autoComplete,
		required,
		label,
		htmlFor,
		onChange,
		type,
		ariaLabel,
		disabled = false,
		className = '',
		description,
		errorMessage,
	} = props;

	const middleWareOnChange = (e: ChangeEvent<HTMLInputElement>) => {
		onChange(e);
	};

	const inputTypeModel = {
		id: id,
		placeholder: placeholder,
		name: name,
		autoComplete: autoComplete,
		required: required,
		onChange: middleWareOnChange,
		type: type,
		'aria-label': ariaLabel,
		disabled: disabled,
		className: className,
		description: description,
		errorMessage: errorMessage,
	};

	return (
		<>
			{errorMessage && (
				<p
					className={`mt-1 inline-flex items-center gap-2 text-base text-minos-form-error-color ${
						type === 'date' || type === 'time' ? 'mb-0' : 'mb-3'
					}`}
				>
					<ErrorIcon />
					{errorMessage}
				</p>
			)}
			<div
				className={`peer relative mb-5 w-full ${
					type === 'date' || type === 'time' ? 'mt-6 !w-44' : 'mt-0'
				} `}
			>
				<label
					htmlFor={htmlFor}
					className={`minos-form-input-label-font-style text-base transition-all peer-placeholder-shown:minos-form-input-value-font-style tablet:minos-form-input-label-font-style tablet:peer-placeholder-shown:minos-form-input-value-font-style peer-placeholder-shown:text-sm peer-disabled:text-transparent ${
						required &&
						'after:ml-0.5 after:font-semibold after:text-minos-form-require-color after:content-["*"]'
					} `}
				>
					{label}
				</label>
				<input
					{...inputTypeModel}
					className={`peer minos-form-input-value-font-style mt-2 size-full rounded-minos-form-input border-minos-form-input-border-width border-minos-form-input-border-color bg-minos-form-input-bg-color p-4 text-base outline outline-0 transition-all placeholder:minos-form-input-value-font-style tablet:minos-form-input-value-font-style placeholder:opacity-50 focus:border-minos-form-input-border-width focus:border-minos-form-secondary-color focus:outline-0 focus:placeholder:text-minos-form-secondary-color disabled:cursor-not-allowed disabled:bg-minos-blue_dark-100 ${className} `}
				/>
				{description ? (
					<p className='minos-form-content-font-style mt-1 text-base tablet:minos-form-content-font-style'>
						{description}
					</p>
				) : null}
			</div>
		</>
	);
}
